import {
  Field,
  FieldType,
  Octopus,
  SelectorField,
} from '@maximizer/core/shared/domain';
import { getFontAwesomeIcon } from './icon-name';

export const getIconForField = (field: Field): string => {
  let type = field.type;
  const icons: Partial<Record<FieldType, string>> = {
    number: 'input-numeric',
    dateTime: 'calendar',
    selector: 'table-cells',
  };

  if (
    field.metadata?.expressions?.value?.length ||
    field.metadata?.type === Octopus.FieldType.DurationField
  ) {
    return getFontAwesomeIcon('flask', 'solid', 16);
  }

  if (field.type === 'selector') {
    const selector = field as SelectorField<unknown>;
    if (
      selector.selection === 'suggest' ||
      selector.selection === 'dialog' ||
      selector.selection === 'autoComplete'
    ) {
      type = 'string';
    }
    if (
      selector.metadata?.type === Octopus.FieldType.BooleanField ||
      selector.metadata?.yesNo
    ) {
      return getFontAwesomeIcon('toggle-on', 'solid', 16);
    }
  }

  return getFontAwesomeIcon(icons[type] ?? 'input-text', null, 16);
};
